import _ from "lodash";
import spacetime, { Spacetime } from "spacetime";

import { getUtcTimeStr } from "@/helpers/util";

export class UtcFormatValueConverter {
  private getUtcString(timestamp: Spacetime, format?: string) {
    timestamp.goto("Etc/Greenwich");

    const formattedDt =
      _.isNil(format) || _.isEmpty(format)
        ? getUtcTimeStr(timestamp)
        : format
            .split(" ")
            .map((a) => `{${a}}`)
            .join(" ");

    return formattedDt;
  }

  toView(value: string | Date | Spacetime, format?: string): string {
    if (!value) return "";
    let date;
    const [timeFormat, addendum] = format?.split(",") || [undefined, undefined];

    if (typeof value === "string" || value instanceof Date) {
      date = spacetime(value);
    } else {
      date = value;
    }

    return `${this.getUtcString(date, timeFormat)}${
      !_.isNil(addendum) ? " " + addendum.trim() : ""
    }`;
  }
}
